/* Euroarabin – subtle reveal animations. Respects prefers-reduced-motion. */
(function(){
  var els=document.querySelectorAll('.hg-reveal');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('is-in'); }); return; }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  },{rootMargin:'0px 0px -8% 0px',threshold:.08});
  els.forEach(function(e){ io.observe(e); });
  /* Safety net: nothing stays hidden if the observer doesn't fire */
  setTimeout(function(){ els.forEach(function(e){ e.classList.add('is-in'); }); },2500);
})();
